import * as actions from './actions';

export const initialState = {
  authenticated: false,
  loginStatuses: {},
  onFetchLoginStatus: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onFetchLoginStatuses: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onLogin: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onLogout: {
    asyncStatus: '',
    message: '',
    status: 0
  }
};

export default (state = initialState, action) => {
  if (action.type === actions.types.ON_FETCH_LOGIN_STATUS_FULFILLED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      authenticated: true,
      onFetchLoginStatus: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_FETCH_LOGIN_STATUS_PENDING) {
    return Object.assign({}, state, {
      onFetchLoginStatus: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_FETCH_LOGIN_STATUS_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      authenticated: false,
      onFetchLoginStatus: { asyncStatus: 'REJECTED', message, status }
    });
  } else if (action.type === actions.types.ON_FETCH_LOGIN_STATUSES_FULFILLED) {
    const { loginStatuses, message, status } = action.data;

    return Object.assign({}, state, {
      loginStatuses,
      onFetchLoginStatuses: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_FETCH_LOGIN_STATUSES_PENDING) {
    return Object.assign({}, state, {
      onFetchLoginStatuses: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_FETCH_LOGIN_STATUSES_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onFetchLoginStatuses: { asyncStatus: 'REJECTED', message, status }
    });
  } else if (action.type === actions.types.ON_LOGIN_FULFILLED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      authenticated: true,
      onLogin: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_LOGIN_PENDING) {
    return Object.assign({}, state, {
      onLogin: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_LOGIN_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      authenticated: false,
      onLogin: { asyncStatus: 'REJECTED', message, status }
    });
  } else if (action.type === actions.types.ON_LOGOUT_FULFILLED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      authenticated: false,
      onLogout: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_LOGOUT_PENDING) {
    return Object.assign({}, state, {
      onLogout: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_LOGOUT_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onLogout: { asyncStatus: 'REJECTED', message, status }
    });
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/qoc-redux/Authentication/reducer.js